import { track } from "../track";

export const trackAvatarCreateFail = (params: {
  avatar_id?: string;
  stage: "submission" | "generation";
  error: string;
}) => track({ event: "avatar_create_fail", ...params });
